export default "__VITE_ASSET__D5YC_T8$__"